import { render, staticRenderFns } from "./ContactsModal.vue?vue&type=template&id=c5fc4fc6&"
import script from "./ContactsModal.vue?vue&type=script&lang=js&"
export * from "./ContactsModal.vue?vue&type=script&lang=js&"
import style0 from "./ContactsModal.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports